import React from "react";

const ActionBlueButtonOrders = ({ text, disabled, partial, ...props }) => {
  return (
    <button
      className={`px-4 ${
        partial ? "w-[160px] !mr-0" : ""
      } py-[6px] gap-2 rounded bg-[#00394d] text-sm font-semibold text-white mr-1 ${
        disabled ? "bg-[#aaaaaa] text-white  cursor-default" : ""
      }`}
      disabled={disabled}
      {...props}
    >
      {text}
    </button>
  );
};

export default ActionBlueButtonOrders;
